import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _dataFromMap,
    _getSplitBar,
    _initSplitBarEvent,
} from "../comJs";
import GridPanelUtils from "./gridPanelUtils";
import GoTabUrl from "../goTabsUrl";

class RoleUserTab extends TabCell {
    allCheckBoxClick() {
        throw new Error("Method not implemented.");
    }

    changeAccountEvent(nodeId, cellObj) {
        if (cellObj.waitSelGrid != null) {
            cellObj.waitSelGrid.clearAll();
        }
        cellObj.initFirstData = true;
        cellObj.loadRoleGrid(nodeId);
    }

    removeSelectedRecord() {
        throw new Error("Method not implemented.");
    }

    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.leftTopGrid != null && AssertUtils.isFunction(this.leftTopGrid.destructor)) {
            this.leftTopGrid.destructor();
            this.leftTopGrid = null;
        }
    }

    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "roleUser";
        this.tabLabel = "角色人员";
        this.hasType=vueObj.hasType;
        this.filter=true;
        this.dataFrom = _dataFromMap["user"];
        this.active = false;
        this.downMin = "common";
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.panelHeight = panelHeight;
        this.leftTopCellHeight = parseFloat(panelHeight + "") * 0.45 - 40;
        this.leftBottomCellHeight = parseFloat(panelHeight + "") * 0.55 - 20;
        let userGridHeight = this.leftBottomCellHeight + "px";

        return `${GridPanelUtils.initLeftCellContent(this, this.leftTopCellHeight, this.leftTopCellHeight - 5 + "px", "请输入角色名称", this.tabId, false, 160, 210)}
            ${_getSplitBar()} 
            <div class="wait-sel-user">
                  <div id="${
            this.tabId
            }_userGrid" style="height: ${userGridHeight};"></div>
             </div>
      `;
    }

    getRightCellContent(panelHeight) {
        return `${GridPanelUtils.initRightCellContent(panelHeight, this, 310)}`;
    }

    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, "角色","roleName","role");
    }


    //初始化tabcell的容器控件
    initTabCellCtl() {
        //初始化角色表格
        this.initRoleGrid();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        let backFun=()=>{
            this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                this.waitSelGrid.deleteRow(recordId);
            });
        };
        //待选数据
        this.initWaitGrid(this.tabId + "_userGrid",backFun);
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: () => {
                this.loadRoleGrid();
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        this.initCtlEvent();
    }

    /**
     * 刷新角色表格
     * @param nodeId
     */
    loadRoleGrid(nodeId) {
        let cellObj = this;
        //缓存账套id
        nodeId = GridPanelUtils.setCurrentAccountId(cellObj, nodeId);
        cellObj.initFirstData = true;
        //只有存在账套id才进行查询
        if (AssertUtils.isNotEmpty(nodeId)) {
            //重新加载岗位表格信息
            this.leftTopGrid.flushGridByUrl({
                url: GoTabUrl.queryRoleByAccountId(nodeId),
                params: GridPanelUtils.getLoadGridParams(cellObj, nodeId, "roleUser"),
                backFun:()=>{
                    this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                        if(AssertUtils.isNotEmpty(recordId)){
                            cellObj.leftTopGrid.deleteRow(recordId);
                        }
                    });
                }
            });
            //清空岗位下用户表格信息
            if (cellObj.waitSelGrid != null) {
                cellObj.waitSelGrid.clearAll();
            }
        }
    }

    /**
     *  初始化角色数据
     */
    initRoleGrid() {
        let cellObj = this;
        cellObj.itemConfig["selLeftTopRecord"] = cellObj.itemConfig["selRow"];
        cellObj.clickType = "flushSubGrid";
        (cellObj).leftTopGrid = GridPanelUtils.initRoleGrid(cellObj, true, true, false,"roleUser",false);
    }

    /**
     * 获取子表的查询url
     * @param rowId
     */
    getSubGridQueryUrl(rowId) {
        return GoTabUrl.getUserByRoleId(rowId);
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }
}

function initRoleUserTab(goTabs, vueObj) {
    let groupTab = new RoleUserTab(vueObj, goTabs);
    goTabs.addTabToFactory("roleUser", groupTab);
}

export default initRoleUserTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/roleUserTab.js